import { useExchangeStore } from "./exchangeStore";
import BigNumber from "bignumber.js";
import { useIndexPrice } from "./indexprice";
import useTradeStore from "./tradeStore";
import { useTradePosition } from "./tradePosition";
import { useBalance } from "../user/mybalance";
import  useGetCoinTier  from "./coinTier";

export const useGetMarginRatio = (item) => {
    const isCross = item?.cross_iso === 'C' // 교차마진이면 true

    const { getCoinTier } = useGetCoinTier()
    const { data: tradeStore } = useTradeStore(); 
    const { EPs } = useExchangeStore();
    const { getPrice } = useIndexPrice(tradeStore?.ep_id || 0);
    const { data : pos } = useTradePosition()
    const currency = tradeStore?.pairs?.split('/')[1]
    const { data: balance } = useBalance(currency, 1);

    return isCross ? crossMarginRatio() : isolatedMarginRatio()

    // 교차마진 증거금비율 ( 전체 유지증거금 / 선물 지갑 전체 자산 * 100 )
    function crossMarginRatio() {
        // 전체 유지증거금
        const sumMm = pos?.reduce((acc, curr) => {
            const EP = EPs?.find(
                (item2: any) => +item2.id == +curr?.exchange_pairs_id
            );
            const currentPrice = getPrice(curr?.exchange_pairs_id);
            const [coin, _] = EP?.pairs?.split('/')
            const amount = curr?.amount * curr?.leverage * currentPrice
            
            // 유지 증거금 계산
            const { mmr, ma } = getCoinTier(coin, amount)
            const maintenanceMargin = curr?.amount * curr?.leverage * curr?.price * mmr - ma
            
            return acc + maintenanceMargin
        }, 0 )

        // 선물 지갑 전체 자산
        const totalDeposit = getTotalDeposit(pos, getPrice, balance)

        return (sumMm / totalDeposit) * 100
    }

    // 격리마진 증거금비율 ( 전체 유지증거금 / 선물 지갑 전체 자산 * 100 )
    function isolatedMarginRatio() {
        const EP = EPs?.find(
            (item2: any) => +item2.id == +item?.exchange_pairs_id
        );
    
        const currentPrice = getPrice(item?.exchange_pairs_id);
        const [coin, _] = EP?.pairs?.split('/')
    
        const amount = item?.amount * item?.leverage * currentPrice;

        // 유지증거금 ( mmr * 수량(USDT) )
        const { mmr, ma } = getCoinTier(coin, amount)
        const maintenanceMargin = item?.amount * item?.leverage * item?.price * mmr - ma

        // 증거금 잔액 ( 증거금 + 미실현 손익 )
        const margin = item?.margin
        const unrealizedplpercent = getUnrealizedplpercent(item, currentPrice, item?.amount * item?.leverage)
        const marginBalance = margin + unrealizedplpercent
    
        return (maintenanceMargin / marginBalance) * 100
    }
}


// 미실현 손익 계산
function getUnrealizedplpercent(item, currentPrice, amount) {
    let pnl = 0;

    if (item?.long_short === 'L') {
        pnl = BigNumber(currentPrice)
        .minus(item?.price) // 진입가
        .multipliedBy(amount)
        .toNumber();
    } else {
        pnl = BigNumber(item?.price)
        .minus(currentPrice)
        .multipliedBy(amount)
        .toNumber();
    }

    return pnl
}

// 선물 지갑 전체 자산
function getTotalDeposit(openPositions, getPrice, balance) {
    let pnl = 0;

    for (let i = 0; i < openPositions?.length; i++) {
    if (openPositions[i].cross_iso == "I") continue;

    if (openPositions[i].long_short === "L") {
        pnl +=
        (getPrice(openPositions?.[i]?.exchange_pairs_id) -
            openPositions?.[i]?.open_price) *
          openPositions[i]?.amount *
        openPositions[i]?.leverage;
    } else {
        pnl +=
          (openPositions[i]?.open_price - getPrice(openPositions?.[i]?.exchange_pairs_id)) *
          openPositions[i]?.amount *
        openPositions[i]?.leverage;
    }
    }

    return  isNaN(BigNumber(balance?.balance).plus(pnl).toNumber())
    ? 0
    : BigNumber(balance?.balance).plus(pnl).toNumber()
}